import React, { useState, useEffect } from 'react'
import { InputText } from '../../../ui'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../StateProvider'
import {
  LATIN_WITH_NUMBERS_SYMBOLS, EMPLOYMENT_ID
} from '../../../constants/constants'
import { usePresetValue } from '../../utils/hooks'
import { getUserValue } from '../utils'

const ExternalEmployerName = ({ i18nLabel, type, name, required, allowNonLatin }) => {
  const { t, i18n } = useTranslation()
  const [value, setValue] = useState('')
  const [error, setError] = useState('')
  const [label, setLabel] = useState(t(`generatedField.${i18nLabel}`))
  const [isValid, setIsValid] = useState(null)
  const [isFilled, setIsFilled] = useState(false)
  const [{ form, form: { accId }, user }, dispatch] = useStore()
  const { employmentSituationId } = form[accId]
  const userValue = getUserValue(accId, user, name)

  useEffect(() => {
    if (employmentSituationId === EMPLOYMENT_ID.UNEMPLOYED || employmentSituationId === EMPLOYMENT_ID.RETIRED) {
      setLabel(t(`generatedField.previous${i18nLabel}`))
    } else {
      setLabel(t(`generatedField.${i18nLabel}`))
    }
  }, [employmentSituationId, i18n.language])

  const presetValue = (value) => {
    setValue(value)
    const isValid = getIsValid(value)
    setIsValid(isValid)
    !value.trim() ? setIsFilled(false) : setIsFilled(true)
    dispatch({ type: 'setExtFieldValue', name, value })
    dispatch({ type: 'setValidationFld', name, value: isValid })
  }

  usePresetValue(name, userValue, presetValue)

  const onChange = ({ target: { value } }) => {
    setValue(value)
    !value.trim() ? setIsFilled(false) : setIsFilled(true)
  }

  const onBlur = ({ target: { name, value } }) => {
    const trimmedValue = value.trim()
    let isValid
    if (!required) {
      isValid = !trimmedValue.length || (trimmedValue.length && getIsValid(trimmedValue))
    } else {
      isValid = getIsValid(trimmedValue)
    }

    if (isValid) {
      setIsValid(true)
      dispatch({ type: 'setExtFieldValue', name, value })
      setError('')
    } else {
      setIsValid(false)
      setError(!isFilled ? '' : 'generatedField.onlyLatin')
    }

    dispatch({ type: 'setValidationFld', name, value: isValid })
  }

  /**
   * @param {string} value
   * @returns {boolean}
   */
  const getIsValid = (value) => allowNonLatin ? !!value.length : LATIN_WITH_NUMBERS_SYMBOLS.test(value)

  return (
    <InputText
      name={name}
      label={label}
      value={value}
      type={type}
      key={name}
      maxLength={200}
      error={t(error)}
      onChange={onChange}
      onBlur={onBlur}
      valid={isValid}
    />
  )
}

const getExternalExternalEmployerNameField = (textField) => {
  const { i18n, name, required, type, order, allowNonLatin } = textField
  return (
    <ExternalEmployerName
      i18nLabel={i18n}
      name={name}
      required={required}
      type={type}
      key={name}
      order={order}
      allowNonLatin={allowNonLatin}
    />
  )
}

export { ExternalEmployerName, getExternalExternalEmployerNameField }
